module.exports = __webpack_public_path__ + "img/HN.0a92ec59.svg";